export default "__VITE_ASSET__b0275df9__"